import { Component, OnInit } from '@angular/core';
import { Subject, zip } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { DemographicsService } from '../demographics/demographics.service';
import { ShiftBidService } from '../shift-bid/shift-bid.service';
import { FeatureFlagService } from '../featureflag.service';
import { RouterLink } from '@angular/router';
import { SharedModulesModule } from '../shared/shared-modules.module';

@Component({
  selector: 'app-shift-bid-options',
  templateUrl: './shift-bid-options.component.html',
  styleUrls: ['./shift-bid-options.component.scss'],
  imports: [
    SharedModulesModule,
    RouterLink,
  ],
})
export class ShiftBidOptionsComponent implements OnInit {

  private unsubscriber: Subject<void> = new Subject<void>();

  mobileChecked = false;
  loading: boolean = true;
  employee_id: string = "";
  profile_id: number = 0;
  primary_location_restriction_flag = true;
  mobile_phone: string = "";
  allLocations = [];
  addedLocations = [];
  availableLocations = [];

  constructor(private demographicsService: DemographicsService,
    private shiftBidService: ShiftBidService,
    private ffservice: FeatureFlagService) { 
    }

  ngOnInit(): void {
    this.demographicsService.getUserData().pipe(
      takeUntil(this.unsubscriber)
    )
      .subscribe(user => {
        this.employee_id = user.employee_id;
        this.setupProfile();
      });
  }

  async setupProfile() {
    await this.getFeatureFlags();

    zip(
      this.shiftBidService.getShiftBidProfile(Number(this.employee_id), true),
      this.demographicsService.getProfilePhone(this.employee_id))
      .pipe(
        takeUntil(this.unsubscriber),
        finalize(() => this.loading = false))
      .subscribe(([profile, phones]) => {
        console.log('Profile: ', profile);
        console.log('Phones: ', phones);
        const mobile = phones.find(phone => phone.phone_type == 'Mobile');
        this.mobile_phone = mobile ? this.formatPhoneNumber(mobile.phone_number) : null;
        this.profile_id = profile.id;
        this.mobileChecked = profile.mobile_opt_in;
        this.allLocations = this.primary_location_restriction_flag ?
          profile.shiftBidLocations.filter(location => location.primary_location) :
          profile.shiftBidLocations;
        this.filterLocations();
      });
  }

  async getFeatureFlags() {
    const shiftBiddingPrimaryLocationFlag = await this.ffservice.getFlagValue('shift-bidding-primary-location-restriction');
    this.primary_location_restriction_flag = shiftBiddingPrimaryLocationFlag;
    console.log('################## primaryLocationRestriction=', shiftBiddingPrimaryLocationFlag);
  }

  mobileOptIn(): void {
    this.loading = true;
    this.shiftBidService.updateShiftBidProfile(this.profile_id, this.mobileChecked).pipe(
      takeUntil(this.unsubscriber),
      finalize(() => this.loading = false)
    ).subscribe(result => {
      if (result) {
        console.log('Opt In Success: ', this.mobileChecked);
      } else {
        this.mobileChecked = !this.mobileChecked;
        console.log('Profile Update Failed');
      }
    });
  }

  formatPhoneNumber(phoneNumber: string): string {
    return '(' + phoneNumber.substring(0, 3) + ') ' + phoneNumber.substring(3, 6) + '-' + phoneNumber.substring(6);
  }

  remove(location: any): void {
    this.loading = true;
    this.shiftBidService.updateShiftBidLocation(location.id, false).pipe(
      takeUntil(this.unsubscriber),
      finalize(() => this.loading = false)
    ).subscribe(result => {
      location.selected = false;
      this.filterLocations();
      console.log('Remove Location Success: ', location.location_id);
      console.log('Number of Responses Affected: ', result);
    });
  }

  accept(location: any): void {
    this.loading = true;
    this.shiftBidService.updateShiftBidLocation(location.id, true).pipe(
      takeUntil(this.unsubscriber),
      finalize(() => this.loading = false)
    ).subscribe(result => {
      location.selected = true;
      this.filterLocations();
      console.log('Accept Location Success: ', location.location_id);
      console.log('Number of Responses Affected: ', result);
    });
  }

  filterLocations(): void {
    this.addedLocations = [];
    this.availableLocations = [];
    this.allLocations.forEach(loc => {
      if (loc.selected) {
        this.addedLocations.push(loc);
      } else {
        this.availableLocations.push(loc);
      }
    });
  }
}
